/* Coltesse custom — sticky reveal v6 (modèle natif « fond figé / avant-plan défilant »)
   Le fond (vidéo/image) d'une section sticky est figé plein écran (position:fixed posé en
   CSS via .sr-enabled) et MONTRÉ/CACHÉ par IntersectionObserver (jamais par image). L'avant-
   plan (bouton/texte, .sr-fg) et les sections voisines défilent en scroll natif et recouvrent
   le fond → fluide iOS, zéro calcul par frame. Plusieurs sticky/page OK (séparées par une
   section normale ; adjacence K-K = effet désactivé sur la 2e).
   Voir docs/superpowers/specs/2026-06-05-sticky-reveal-native-design.md */
(function () {
  if (window.__stickyRevealInit) return;
  window.__stickyRevealInit = true;

  var reduceMQ =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');
  var root = document.documentElement;
  var enabled = []; // sections (#section-id) où l'effet s'applique
  var io = null;
  var reInitTimer = 0;

  function wrapperOf(spacer) {
    return spacer.closest ? spacer.closest('.shopify-section') : null;
  }

  // voisine .shopify-section (1 = suivante, -1 = précédente)
  function adjacentSection(spacer, dir) {
    var node = wrapperOf(spacer);
    if (!node) return null;
    node = dir > 0 ? node.nextElementSibling : node.previousElementSibling;
    while (node && !(node.classList && node.classList.contains('shopify-section'))) {
      node = dir > 0 ? node.nextElementSibling : node.previousElementSibling;
    }
    return node;
  }

  function isStickyWrapper(wrapper) {
    return !!(wrapper && wrapper.querySelector('[data-sticky-reveal]'));
  }

  function buildEnabledList() {
    var all = Array.prototype.slice.call(
      document.querySelectorAll('[data-sticky-reveal]')
    );
    enabled = [];
    all.forEach(function (spacer) {
      // K-K : si la précédente est elle-même sticky → je suis la plus tardive → désactivé.
      if (isStickyWrapper(adjacentSection(spacer, -1))) {
        if (window.console && console.warn) {
          var w = wrapperOf(spacer);
          console.warn(
            '[sticky-reveal] Deux sections sticky adjacentes — effet désactivé sur la ' +
              'plus tardive (' +
              (w && w.id ? '#' + w.id : '?') +
              '). Insérez une section normale entre deux sticky.'
          );
        }
        return;
      }
      enabled.push(spacer);
    });
  }

  function destroy() {
    if (io) {
      io.disconnect();
      io = null;
    }
    enabled.forEach(function (s) {
      s.classList.remove('sr-active');
    });
    enabled = [];
    root.classList.remove('sr-enabled');
  }

  function init() {
    destroy();
    if (reduceMQ && reduceMQ.matches) return; // a11y : pas d'épinglage → bannière normale
    if (!('IntersectionObserver' in window)) return; // dégradation gracieuse
    buildEnabledList();
    if (!enabled.length) return;
    root.classList.add('sr-enabled'); // active le position:fixed du fond (CSS)
    io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          var active = e.isIntersecting;
          e.target.classList.toggle('sr-active', active);
          // iOS : la vidéo de fond ne démarre pas seule quand son conteneur est masqué/figé
          // au chargement (play() rejeté au loadeddata, jamais réessayé). On la (re)lance à
          // l'activation — visible et en place → play() autorisé (muted + playsinline).
          var v = e.target.querySelector('video');
          if (v) {
            if (active) {
              if (v.paused) {
                var pr = v.play();
                if (pr && pr.catch) pr.catch(function () {});
              }
            } else if (!v.paused) {
              v.pause();
            }
          }
        });
      },
      { threshold: 0 }
    );
    enabled.forEach(function (s) {
      io.observe(s);
    });
  }

  function scheduleReInit() {
    clearTimeout(reInitTimer);
    reInitTimer = setTimeout(init, 50);
  }

  init();

  document.addEventListener('shopify:section:load', scheduleReInit);
  document.addEventListener('shopify:section:unload', scheduleReInit);

  if (reduceMQ) {
    if (reduceMQ.addEventListener) reduceMQ.addEventListener('change', init);
    else if (reduceMQ.addListener) reduceMQ.addListener(init);
  }
})();
